module.exports = __webpack_public_path__ + "static/media/ticket-event.e752ba9a.svg";